/**
 * Xantho CRO fixes — round 2 (mei 2026)
 *
 * Fixes ingebouwd op basis van:
 *   - Microsoft Clarity data 02-04/05/2026 (78% in-app browser, JS errors,
 *     CLS=0.782, INP=270ms, ATC→checkout drop 93%)
 *   - GA4 30d export (trailing-slash duplicate URLs, 0 conversions tracked)
 *
 * Wordt geladen via layout/theme.liquid.
 * Geen externe deps, ES2017+, < 4kb gz.
 */
(function () {
  'use strict';

  var DEBUG = false;
  var log = DEBUG ? console.log.bind(console, '[xantho-cro]') : function () {};

  /* ===================================================================== *
   * 1. TRAILING SLASH REDIRECT (canonical-aware)
   *    GA4: /products/dagcreme-spf20/ heeft 7.5% engagement vs 35% voor
   *    /products/dagcreme-spf20. Paid Meta ads sturen naar de /-versie.
   *    Fix: client-side history.replaceState naar canonical (zonder reload),
   *    en als pagina nog niet bestaat → 301-stijl redirect.
   * ===================================================================== */
  (function fixTrailingSlash() {
    try {
      var p = location.pathname;
      // Skip root, en /xx/ locale roots
      if (p === '/' || /^\/[a-z]{2}\/?$/i.test(p)) return;
      // Alleen op product/collection/page/blog paths met trailing slash
      if (!/\/$/.test(p)) return;
      if (!/^\/(products|collections|pages|blogs)\//.test(p) &&
          !/^\/[a-z]{2}\/(products|collections|pages|blogs)\//.test(p)) return;
      var clean = p.replace(/\/$/, '');
      var newUrl = clean + location.search + location.hash;
      // Prefer history.replaceState zodat user state behouden blijft
      if (window.history && history.replaceState) {
        history.replaceState(null, '', newUrl);
        log('trailing slash stripped:', p, '→', clean);
      }
      // Update canonical link in head zodat Google de juiste indexeert
      var canon = document.querySelector('link[rel="canonical"]');
      if (canon) canon.href = canon.href.replace(/\/$/, '');
    } catch (e) { log('trailing-slash error', e); }
  })();

  /* ===================================================================== *
   * 2. IN-APP BROWSER DETECTIE + BANNER
   *    Clarity: 64% FacebookApp + 14% InstagramApp = 78% in-app traffic.
   *    Alle 5 top-JS-errors zijn in-app webview quirks (recordcounter,
   *    _autofillcallbackhandler, java object is gone, script error).
   *    Fix: bied "open in Safari/Chrome" met platform-correct deeplink.
   * ===================================================================== */
  (function inAppBrowserBanner() {
    var ua = navigator.userAgent || '';
    var isFB = /FBAN|FBAV|FB_IAB|FBIOS/i.test(ua);
    var isIG = /Instagram/i.test(ua);
    var isLine = /Line\//i.test(ua);
    var isTikTok = /BytedanceWebview|musical_ly|Bytedance/i.test(ua);
    var isInApp = isFB || isIG || isLine || isTikTok;
    if (!isInApp) return;

    // Niet vaker dan 1× per 24u tonen
    try {
      var dismissed = localStorage.getItem('xantho_iab_dismissed');
      if (dismissed && (Date.now() - parseInt(dismissed, 10)) < 86400000) return;
    } catch (e) {}

    var isIOS = /iPhone|iPad|iPod/i.test(ua);
    var isAndroid = /Android/i.test(ua);

    function buildExternalUrl() {
      var url = location.href;
      if (isAndroid) {
        // Android intent → opent in default browser (meestal Chrome)
        var host = location.host;
        var path = location.pathname + location.search + location.hash;
        return 'intent://' + host + path +
               '#Intent;scheme=https;package=com.android.chrome;' +
               'S.browser_fallback_url=' + encodeURIComponent(url) + ';end';
      }
      if (isIOS) {
        // iOS: x-safari-https://... opent in Safari (Chrome variant: googlechromes://)
        return 'x-safari-' + url.replace(/^https?:/, 'https:');
      }
      return url;
    }

    function show() {
      if (document.querySelector('.xantho-iab-banner')) return;
      var banner = document.createElement('div');
      banner.className = 'xantho-iab-banner';
      banner.setAttribute('role', 'dialog');
      banner.setAttribute('aria-label', 'Open in browser');
      banner.innerHTML =
        '<div class="xantho-iab-banner__text">' +
        'Voor de beste ervaring (en om je bestelling vlot te plaatsen): ' +
        'open Xantho in je browser.' +
        '</div>' +
        '<a class="xantho-iab-banner__cta" href="' + buildExternalUrl() + '" ' +
        'target="_blank" rel="noopener">Open in browser</a>' +
        '<button class="xantho-iab-banner__close" aria-label="Sluiten">×</button>';
      document.body.appendChild(banner);
      document.body.classList.add('xantho-iab-active');
      requestAnimationFrame(function () {
        banner.classList.add('is-visible');
      });
      banner.querySelector('.xantho-iab-banner__close').addEventListener('click', function () {
        banner.classList.remove('is-visible');
        document.body.classList.remove('xantho-iab-active');
        try { localStorage.setItem('xantho_iab_dismissed', String(Date.now())); } catch (e) {}
        setTimeout(function () { banner.remove(); }, 400);
      });
      // Track dismiss reason via Clarity custom tag
      banner.querySelector('.xantho-iab-banner__cta').addEventListener('click', function () {
        if (window.clarity) window.clarity('set', 'iab_cta_clicked', 'true');
      });
      if (window.clarity) window.clarity('set', 'in_app_browser', isFB ? 'fb' : isIG ? 'ig' : 'other');
    }

    // Wacht tot first interaction of 1.5s zodat banner LCP niet vertraagt
    if (document.readyState === 'complete') {
      setTimeout(show, 1500);
    } else {
      window.addEventListener('load', function () { setTimeout(show, 1500); });
    }
  })();

  /* ===================================================================== *
   * 3. GLOBAL JS ERROR SUPPRESSOR (alleen voor bekende WebView-noise)
   *    Voorkomt dat in-app-browser quirks naar onze Sentry/Clarity vervuilen
   *    en stopt cascading errors die soms volgende click handlers breken.
   * ===================================================================== */
  (function suppressWebViewErrors() {
    var KNOWN_WEBVIEW_NOISE = [
      /recordcounter/i,
      /_autofillcallbackhandler/i,
      /java object is gone/i,
      /enablebuttonsclickedmetadatalogging/i,
      /Script error\.?$/
    ];
    window.addEventListener('error', function (e) {
      var msg = (e && e.message) || '';
      for (var i = 0; i < KNOWN_WEBVIEW_NOISE.length; i++) {
        if (KNOWN_WEBVIEW_NOISE[i].test(msg)) {
          e.stopImmediatePropagation();
          return true;
        }
      }
    }, true);
  })();

  /* ===================================================================== *
   * 4. CART → CHECKOUT FUNNEL TRACKING + AUTO-FOCUS CHECKOUT
   *    93% drop tussen ATC (1.96%) en checkout (0.13%).
   *    Hypothese: drawer opent maar checkout-knop wordt niet gezien.
   *    Fix: scroll naar checkout-knop bij drawer open, en track elke stap
   *    via Clarity smart events zodat we kunnen meten waar de drop zit.
   * ===================================================================== */
  (function cartFunnelFix() {
    function fireClarity(event, value) {
      try {
        if (window.clarity) window.clarity('event', event);
        if (DEBUG) log('clarity:', event, value);
      } catch (e) {}
    }

    // Stap 1: ATC click
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-add-to-cart]')) {
        fireClarity('xantho_atc_click');
      }
    }, true);

    // Stap 2: cart drawer geopend
    document.addEventListener('theme:drawer:open', function (e) {
      var drawer = e.target;
      if (drawer && drawer.matches && drawer.matches('[data-drawer="drawer-cart"]')) {
        fireClarity('xantho_drawer_opened');
        // (auto-scrollIntoView verwijderd — kon op mobile interactie blokkeren
        // tijdens drawer-open animatie. Pulse + grotere knop is genoeg.)
      }
    });

    // Stap 3: checkout-knop click
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.checkout__button, button[name="checkout"]');
      if (btn) fireClarity('xantho_checkout_click');
    }, true);

    // Stap 4: cart page bezocht
    if (location.pathname === '/cart' || /\/cart$/.test(location.pathname)) {
      fireClarity('xantho_cart_page_view');
    }
  })();

  /* ===================================================================== *
   * 5. GA4 PURCHASE FALLBACK (0 conversions in 30d export = tracking gap)
   *    Als shop.com gebruik maakt van Shopify Pixels API hoort dit niet
   *    nodig te zijn, maar fallback dekt het gat tot dat is opgelost.
   *    Werkt alleen op /thank_you / order-status pagina's.
   * ===================================================================== */
  (function ga4PurchaseFallback() {
    if (!/\/(thank_you|orders\/[a-z0-9]+)/i.test(location.pathname) &&
        !/Shopify\.Checkout\.OrderStatus/.test(document.documentElement.innerHTML)) return;
    if (typeof window.gtag !== 'function' && typeof window.dataLayer === 'undefined') return;
    if (window.__xanthoPurchaseFired) return;
    window.__xanthoPurchaseFired = true;

    var checkout = (window.Shopify && window.Shopify.checkout) || null;
    if (!checkout) return;

    var payload = {
      transaction_id: checkout.order_id || checkout.token,
      value: parseFloat(checkout.total_price) / 100,
      currency: checkout.currency || 'EUR',
      tax: parseFloat(checkout.total_tax || 0) / 100,
      shipping: parseFloat(checkout.shipping_rate ? checkout.shipping_rate.price : 0) / 100,
      items: (checkout.line_items || []).map(function (li) {
        return {
          item_id: li.product_id || li.variant_id,
          item_name: li.title,
          item_variant: li.variant_title,
          price: parseFloat(li.price) / 100,
          quantity: li.quantity
        };
      })
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'purchase', payload);
    } else if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: 'purchase', ecommerce: payload });
    }
    log('GA4 purchase fired', payload);
  })();

  /* ===================================================================== *
   * 6. INP — defer non-critical scripts en ontkoppel zware listeners
   *    Clarity INP=270ms (target <200). Pipeline laadt vendor.js+theme.js
   *    al defer. Hier idle-load voor 3rd-party.
   * ===================================================================== */
  (function inpHelpers() {
    // Maak smooth-scroll click handlers passive (niet blokkerend voor scroll)
    var passive = { passive: true };
    ['touchstart', 'touchmove', 'wheel'].forEach(function (evt) {
      window.addEventListener(evt, function () {}, passive);
    });

    // Idle-defer Fera reviews script als die nog niet geladen is en pas op PDP
    if (/\/products\//.test(location.pathname) && 'requestIdleCallback' in window) {
      requestIdleCallback(function () {
        // Trigger Fera re-init na idle zodat het LCP niet vertraagt
        if (window.feraInit && typeof window.feraInit === 'function') {
          try { window.feraInit(); } catch (e) {}
        }
      }, { timeout: 3000 });
    }
  })();

  /* ===================================================================== *
   * 7. STICKY CTA op /pages/hoe-het-werkt
   *    GA4: 3981 sessies (#1 traffic), 20% engagement, mostly FB/IG paid.
   *    Toon na 30% scroll, link naar /collections/sets-routines.
   * ===================================================================== */
  (function stickyCtaHoeHetWerkt() {
    if (!/\/pages\/hoe-het-werkt/i.test(location.pathname)) return;
    if (document.querySelector('.xantho-sticky-cta')) return;

    var cta = document.createElement('a');
    cta.className = 'xantho-sticky-cta';
    cta.href = '/collections/sets-routines';
    cta.textContent = 'Start je routine →';
    cta.setAttribute('data-xantho-cta', 'hoe-het-werkt');
    document.body.appendChild(cta);

    var shown = false;
    function onScroll() {
      var pct = (window.scrollY + window.innerHeight) /
                document.documentElement.scrollHeight;
      if (!shown && pct > 0.30) {
        cta.classList.add('is-visible');
        shown = true;
        if (window.clarity) window.clarity('event', 'xantho_sticky_cta_shown');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    cta.addEventListener('click', function () {
      if (window.clarity) window.clarity('event', 'xantho_sticky_cta_click');
    });
  })();

  /* ===================================================================== *
   * 7b. PDP TRUST STRIP — injectie direct onder ATC-knop op product pages
   *     Toont: gratis verzending, 30d garantie, Belgisch, in apotheken.
   *     Targets de 2 grootste landings (/products/serum 5528 sessies/90d
   *     en /products/dagcreme-spf20 4602 sessies/90d) maar werkt op alle PDP's.
   * ===================================================================== */
  (function pdpTrustStrip() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.querySelector('.xantho-pdp-trust')) return;

    function init() {
      var atcBtn = document.querySelector('[data-add-to-cart], button[name="add"], .product-form__submit, .btn--add-to-cart');
      if (!atcBtn) { setTimeout(init, 500); return; }
      var formWrap = atcBtn.closest('form, [data-product-form-wrapper], .product-form, .product__form') || atcBtn.parentElement;
      if (!formWrap) return;

      // Annelies feedback (05/05): "Gratis verzending" en "30 dagen" zijn al
      // bij de 3 vinkjes elders op de PDP, dus hier alleen de twee unieke
      // trust-signals die er NIET dubbel komen.
      var strip = document.createElement('ul');
      strip.className = 'xantho-pdp-trust';
      strip.innerHTML =
        '<li><span class="xantho-pdp-trust__ico">🇧🇪</span>Made in Belgium · in 700+ apotheken</li>' +
        '<li><span class="xantho-pdp-trust__ico">🧪</span>Dermatologisch getest · zwangerschapsproof</li>';
      formWrap.appendChild(strip);
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();

  /* ===================================================================== *
   * 8. MOBILE STICKY ATC BAR (PDP only) — typisch +15-25% mobile ATC
   * ===================================================================== */
  (function stickyAtcMobile() {
    if (!/\/products\//.test(location.pathname)) return;
    if (window.innerWidth >= 768) return;
    if (document.querySelector('.xantho-sticky-atc')) return;

    function init() {
      var realBtn = document.querySelector('[data-add-to-cart], button[name="add"], .product-form__submit, .btn--add-to-cart');
      if (!realBtn) { setTimeout(init, 600); return; }
      var titleEl = document.querySelector('.product__title, h1.product-page__title, h1');
      var productTitle = titleEl ? titleEl.textContent.trim() : 'Dit product';
      var priceEl = document.querySelector('.product__price--sale, [data-product-price], .product__price');
      var price = priceEl ? priceEl.textContent.trim() : '';

      var bar = document.createElement('div');
      bar.className = 'xantho-sticky-atc';
      bar.innerHTML =
        '<div class="xantho-sticky-atc__info">' +
          '<span class="xantho-sticky-atc__title">' + (productTitle.length > 28 ? productTitle.substring(0, 28) + '…' : productTitle) + '</span>' +
          (price ? '<span class="xantho-sticky-atc__price">' + price + '</span>' : '') +
        '</div>' +
        '<button type="button" class="xantho-sticky-atc__btn">In winkelwagen</button>';
      document.body.appendChild(bar);

      bar.querySelector('.xantho-sticky-atc__btn').addEventListener('click', function () {
        if (window.clarity) window.clarity('event', 'xantho_sticky_atc_click');
        realBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { realBtn.click(); }, 350);
      });

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) bar.classList.remove('is-visible');
          else bar.classList.add('is-visible');
        });
      }, { rootMargin: '0px 0px -40px 0px' });
      observer.observe(realBtn);
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();

  /* ===================================================================== *
   * 9. IMAGE DECODING + LAZY AUDIT — main-thread relief
   * ===================================================================== */
  (function imageAudit() {
    function audit() {
      var imgs = document.querySelectorAll('img:not([data-xantho-audited])');
      imgs.forEach(function (img) {
        img.dataset.xanthoAudited = '1';
        if (!img.hasAttribute('decoding')) img.decoding = 'async';
        var rect = img.getBoundingClientRect();
        var isAboveFold = rect.top < window.innerHeight * 1.2;
        if (!isAboveFold && !img.hasAttribute('loading')) {
          img.loading = 'lazy';
        }
      });
    }
    if (document.readyState !== 'loading') audit();
    else document.addEventListener('DOMContentLoaded', audit);
    document.addEventListener('theme:cart:change', function () { setTimeout(audit, 200); });
  })();

})();
